import { Link } from "react-router-dom";
import { PageContainer } from "@/components/layout/PageContainer";
import { useAuth } from "@/state/AuthContext";
import { Calendar, Users, User, Settings } from "lucide-react";
import { BirthdaysThisMonthCard } from "./BirthdaysThisMonthCard";
import { GalleriesCard } from "./GalleriesCard";
import { RegisterForBadgerCard } from "./RegisterForBadgerCard";

export function MembersDashboard() {
  const { user, isMember } = useAuth();

  const links = [
    { to: "/events", label: "Events", icon: Calendar },
    ...(isMember ? [{ to: "/roster", label: "Roster", icon: Users }] : []),
    { to: "/profile", label: "My Profile", icon: User },
    { to: "/settings/profile", label: "Settings", icon: Settings },
  ];

  return (
    <PageContainer>
      <h1 className="text-2xl font-bold">
        Welcome{user?.first_name ? `, ${user.first_name}` : ""}
      </h1>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {links.map(({ to, label, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="flex flex-col items-center justify-center gap-3 rounded-lg border bg-card p-8 text-card-foreground shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground"
          >
            <Icon className="size-8 text-muted-foreground" />
            <span className="text-sm font-medium">{label}</span>
          </Link>
        ))}
        {/* Non-members (accounts with no linked member record) can't call the
            member-only birthdaysThisMonth procedure, so skip rendering it. */}
        {isMember && <BirthdaysThisMonthCard />}
        <GalleriesCard />
        <RegisterForBadgerCard />
      </div>
    </PageContainer>
  );
}
